module.exports = __webpack_public_path__ + "img/allshow.ac809b8f.png";